import { newBoxDefaultEntries } from 'apps/studio/components/choices'
import { lib } from '@gocanvas/client'
const { GC_BLANK_DEFAULT } = lib

const NumberOfChoicesSelect = {
  label: 'Number of Choices',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'maximum',
  dynamicChoices: entry => {
    return [2, 3, 4, 5].map(option => {
      const { default: defaultValue, entry_values = [] } = entry
      const newEntryValues = newBoxDefaultEntries(option, entry_values).filter(
        ({ text }) => text !== undefined
      )
      const validDefaultValue =
        newEntryValues.find(({ text }) => text === defaultValue)?.text ||
        GC_BLANK_DEFAULT

      return {
        value: option,
        label: option,
        additionalProperties: {
          entry_values: newEntryValues,
          default: validDefaultValue,
        },
      }
    })
  },
}

export const SingleChoiceBoxesChoicesSettings = [NumberOfChoicesSelect]
